<ion-modal [isOpen]="displayOddModal">
  <ng-template>
    <ion-content fullscreen="true" scroll-y="true" class="ion-padding odd-modal">
      <app-home-odd-modal
        [oddDate]="customer.saxo_data_renewal_expires_at"
        [name]="customer.first_name"
        (review)="onReview()"
        (doItLater)="onDoItLater()"
      ></app-home-odd-modal>
    </ion-content>
  </ng-template>
</ion-modal>

<ion-modal [isOpen]="displayEve2ConsentModal">
  <ng-template>
    <ion-content fullscreen="true" scroll-y="true" class="ion-padding eve2-consent-modal">
      <app-account-eve2-consent
        [loading]="eve2LoadState === 'LOADING'"
        (downloadDoc)="onDownloadConsentDoc()"
        (optIn)="onEve2OptIn()"
        (reviewLater)="onReviewLater()"
      ></app-account-eve2-consent>
    </ion-content>
  </ng-template>
</ion-modal>

<ion-modal [isOpen]="displayEve2ConsentSuccessModal">
  <ng-template>
    <ion-content fullscreen="true" scroll-y="true" class="ion-padding eve2-consent-modal">
      <app-account-eve2-consent-success (closeModal)="onCloseOptInSuccess()"></app-account-eve2-consent-success>
    </ion-content>
  </ng-template>
</ion-modal>

<ion-content [fullscreen]="true" [scrollY]="true" data-cy="home.content" class="ion-padding">
  <!-- Notifications -->
  <div class="home-notifications" *ngIf="notifications.length">
    <div class="notification-item" (click)="openNotificationPage(notification)" [@notificationAnim]="notification !== null">
      <div class="notification-item__wrapper">
        <div class="notification-item__content" [ngClass]="{ 'with-image': notification?.attributes.image }">
          <b>{{ notification?.attributes?.title }}</b>
          <div [innerHTML]="notification?.attributes?.body"></div>
        </div>
        <div
          *ngIf="notification?.attributes?.image"
          class="notification-item__image"
          [ngStyle]="{
            'background-image': 'url(' + notification?.attributes.image + ')'
          }"
        ></div>
        <ion-icon class="close" name="close" color="tertiary" (click)="dissmissNotification(notification); $event.stopPropagation()"></ion-icon>
      </div>
      <ng-container *ngIf="notifications.length > 1">
        <div class="first-stack"></div>
        <div class="second-stack"></div>
      </ng-container>
    </div>
  </div>
  <app-home-campaign-banner
    *ngFor="let promoCampaign of promoCampaigns$ | async"
    [currency]="customer.temporary_accounts[0].account_currency"
    [campaign]="promoCampaign"
  ></app-home-campaign-banner>
  <div *appFeatureFlag="'3a_banner_push'">
    <div class="banner-3a" *ngIf="!!active3aAccount" (click)="open3aModal()">
      <h2 class="ds-heading-2">{{ 'HOME.existingAccount.CTA' | translate }}</h2>
    </div>
  </div>

  <!-- List of all accounts -->
  <div>
    <!-- Grow Banner -->
    @if (customer.show_interest_account_banner) {
      @if (isGrowChf300Campaign$ | async) {
        <div class="banner-grow" (click)="openBannerModal('growChf300', '/grow/intro')">
          <h2 class="ds-heading-3" [innerHTML]="'HOME.newGrowCampaign.CTA' | translate"></h2>
        </div>
      } @else {
        @let growAccountItem = customerGrowAccountItem$ | async;
        <div class="ds-card grow-banner" (click)="openGrow(growAccountItem)">
          <app-ds-rounded-icon
            icon="earth"
            variant="custom"
            customColor="var(--color-core-brand-1-5)"
            color="var(--color-core-neutral-0)"
          ></app-ds-rounded-icon>
          <div class="campaign-info">
            <h2 class="ds-heading-2">{{ 'GROW.banner.title' | translate }}</h2>
            <div class="ds-ui-3 ds-color-core-neutral-7">{{ 'GROW.banner.claim' | translate }}</div>
          </div>
          <ion-icon name="chevron-forward-outline"></ion-icon>
        </div>
      }
    }

    <!-- end Grow Banner -->
    <!-- Eve2 -->
    @if (showEve2Banner$ | async) {
      <div class="home-eve2-banner">
        <div></div>
        <div>
          <p class="ds-heading-2">{{ 'EVE2.notification.title' | translate }}</p>
          <p class="ds-running-2">
            {{ 'EVE2.notification.description' | translate }}.
            <a [href]="eve2BannerUrl" target="_blank">{{ 'EVE2.notification.link' | translate }}.</a>
          </p>
        </div>
      </div>
    }

    @if (showEve23aBanner$ | async) {
      <div class="home-eve2-banner">
        <div></div>
        <div>
          <p class="ds-heading-2">{{ 'EVE2.notification.title' | translate }}</p>
          <p class="ds-running-2">
            {{ 'EVE2.notification.description_3a' | translate }}.
            <a [href]="eve2BannerUrl" target="_blank">{{ 'EVE2.notification.link' | translate }}.</a>
          </p>
        </div>
      </div>
    }
    <!-- end Eve2 -->
    <h2 class="title">{{ 'HOME.investments.title' | translate }}</h2>
    <div class="home-accounts">
      <app-home-accounts-item
        *ngFor="let key of getObjectKeys(accountsHomepage)"
        [accountKind]="accountsHomepage[key]?.account?.kind"
        [currencyShares]="currencyShares"
        [currencyInvestment]="accountsHomepage[key]?.account?.account_currency"
        [accountHomepage]="accountsHomepage[key]"
        [hasTechnicalIssues]="hasTechnicalIssues(accountsHomepage[key].account)"
        (click)="goToPerformance(accountsHomepage[key]?.account.id)"
      ></app-home-accounts-item>
      <!-- GROW account -->
      @if (customer.has_interest_account) {
        <div
          *ngIf="customerGrowAccountItem$ | async as customerGrowAccountItem"
          class="grow-info-row"
          (click)="goToPerformance(customerGrowAccountItem?.id)"
        >
          {{ 'GROW.intro.title' | translate }}
          <div class="info-row-amount">
            <ng-container *ngIf="inyovaGrowAccount.id; else growLoading">
              <span>{{ inyovaGrowAccount.currency }}</span>
              {{ inyovaGrowAccount.portfolio_value?.toFixed() | thousand }}
            </ng-container>
            <ng-template #growLoading>
              <ion-skeleton-text animated></ion-skeleton-text>
            </ng-template>
          </div>
        </div>
      }

      <!-- end GROW account -->
      <app-home-accounts-item
        *ngIf="customer?.has_crowd_investor_account"
        [accountKind]="'ci'"
        [currencyShares]="currencyShares"
        [currencyInvestment]="currencyShares"
        [crowdinvestingTotalValue]="crowdinvestingValues?.total_stock_value"
        (click)="goToPerformance(null)"
      ></app-home-accounts-item>
    </div>
  </div>

  <!-- Impact metrics -->
  <ng-container *ngIf="(isImpact2Active$ | async) === false && impactMetrics?.length > 0">
    <div class="home-impact-wrapper" routerLink="/tabs/impact" (click)="amplitudeTrack('Impact Opened', { action_source: 'on_page_link' })">
      <h2 class="title">{{ 'HOME.impactTitle' | translate }}</h2>
      <div class="home-impact-items">
        <div class="home-impact-item" [ngClass]="'items-' + impactMetrics.length" *ngFor="let metric of impactMetrics">
          <img [ngClass]="metric.name" src="{{ '/assets/images/' + metric.name + '.png' }}" alt="" />
          <div>
            <strong>
              {{ metric.value.toFixed(0) | thousand }}
              <span>{{ metric.units }}</span>
            </strong>
            <br />
            <span [ngClass]="metric.name">{{ 'INSIGHTS.metrics.' + metric.name | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <!-- News feed -->
  <ng-container *ngIf="isStoriesLoading$ | async; else showContent">
    <ion-skeleton-text animated class="image-holder"></ion-skeleton-text>
    <ion-skeleton-text animated></ion-skeleton-text>
    <ion-skeleton-text animated style="width: 75%"></ion-skeleton-text>
  </ng-container>
  <ng-template #showContent>
    <ng-container *ngIf="pagedStories.length">
      <div class="impact-stories">
        <div class="impact-stories__header">
          <h2 class="title">{{ 'HOME.news.title' | translate }}</h2>
          <div
            class="impact-stories__header-filter"
            [class.impact-stories__header-filter--active]="filterValue"
            *ngIf="showFilter"
            (click)="openPicker()"
          >
            <ion-icon name="options-outline"></ion-icon>
            <span>{{ 'INSIGHTS.impact.stories.filter' | translate }}</span>
          </div>
        </div>
      </div>
      <div class="impact-stories__list">
        <app-impact-stories-item
          *ngFor="let item of pagedStories"
          [language]="customer?.language"
          [item]="item"
          (openDetail)="openDetail(item)"
        ></app-impact-stories-item>
      </div>
      <ion-infinite-scroll threshold="50px" (ionInfinite)="loadStories($event)" *ngIf="pagedStories?.length !== stories?.length">
        <ion-infinite-scroll-content loadingSpinner="bubbles"></ion-infinite-scroll-content>
      </ion-infinite-scroll>
    </ng-container>
  </ng-template>
</ion-content>
